import { Box, useMediaQuery } from '@mui/material';
import { theme } from '~/theme';
import { useFieldArray, useFormContext } from 'react-hook-form';
import { TPurposeOfBusinessRelations } from '~/modules/identification/forms/BusinessRelations/types.ts';
import {
  EMPTY_INFO_CONTACTS,
  infoContactsTableColumns,
} from '~/modules/identification/forms/BusinessRelations/constants.ts';
import { FormYesNoQuestion } from '~/components/FormComponents/FormYesNoQuestion.tsx';
import { TableHeader } from '~/components/ListCardTable/TableHeader.tsx';
import { InfoContactsTable } from '~/modules/identification/forms/BusinessRelations/components/InfoContacts/InfoContactsTable.tsx';
import { styles } from '../../styles';
import { commonStyles } from '~/theme/styles/commonStyles';

export const TradingInfo = () => {
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const { control, clearErrors, watch } = useFormContext<TPurposeOfBusinessRelations>();
  const isTradingInfoOnCapitalMarketsProvided = watch('isTradingInfoOnCapitalMarketsProvided');
  const { fields, append, remove, replace } = useFieldArray({
    control,
    name: 'tradingInfoContacts',
  });

  const handleChangeTradingInfo = (isChecked: boolean) => {
    if (isChecked) {
      replace([EMPTY_INFO_CONTACTS]);
    } else {
      replace([]);
      clearErrors('tradingInfoContacts');
    }
  };

  return (
    <>
      <FormYesNoQuestion
        name="isTradingInfoOnCapitalMarketsProvided"
        question={
          'Чи планується надавати інформацію щодо торгівлі фінансовими інструментами на ринках капіталу?'
        }
        tooltipTitle={
          "Вкажіть контакти осіб, яким надаватиметься інформація щодо торгівлі фінансовими інструментами. Дані передаватимуться відкритими каналами зв'язку (електронні комунікаційні мережі загального користування). Максимум 5 контактів"
        }
        onChange={handleChangeTradingInfo}
      />
      {isTradingInfoOnCapitalMarketsProvided && (
        <Box sx={styles.table}>
          {!isMobile && <TableHeader columns={infoContactsTableColumns} showActions />}
          <Box sx={{ ...commonStyles.columnFlexContainer, gap: { sm: 2, md: 0, xs: 2 } }}>
            {fields.map((field, index: number) => (
              <InfoContactsTable
                key={field.id}
                name={'tradingInfoContacts'}
                index={index}
                showRemove={fields.length > 1}
                shownAppend={fields.length < 5}
                append={append}
                remove={remove}
              />
            ))}
          </Box>
        </Box>
      )}
    </>
  );
};
